import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const API_BASE = '/api/v1/super-ip';
const CONFIG_API_BASE = '/api/v1/super-ip';

const getToken = () => localStorage.getItem('token');

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const configApi = axios.create({
  baseURL: CONFIG_API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

configApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== 样式组件 ====================
const Container = styled.div`
  min-height: 100vh;
  background: var(--bg-dark);
  display: flex;
  flex-direction: column;
  position: relative;
  &::before {
    content: '';
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: radial-gradient(ellipse at 20% 50%, rgba(0,240,255,0.03) 0%, transparent 50%),
                radial-gradient(ellipse at 80% 20%, rgba(123,44,191,0.04) 0%, transparent 50%);
    pointer-events: none;
    z-index: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: rgba(18,18,26,0.8);
  backdrop-filter: blur(20px);
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const LogoIcon = styled.div`
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  box-shadow: var(--glow-primary);
`;

const LogoText = styled.h1`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.4rem;
  margin: 0;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 2px;
`;

const UserMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserAvatar = styled.div`
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, var(--primary), var(--accent));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #000;
  font-weight: 700;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  position: relative;
  z-index: 1;
`;

const ModuleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
`;

const ModuleCard = styled.div`
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    transform: translateY(-4px);
    border-color: var(--primary);
    box-shadow: var(--glow-primary);
  }
`;

const ModuleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const ModuleIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  background: ${props => props.gradient};
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
`;

const ModuleTitle = styled.h2`
  margin: 0;
  font-family: 'Orbitron', sans-serif;
  font-size: 1.3rem;
  color: var(--text-primary);
  letter-spacing: 1px;
`;

const ModuleDesc = styled.p`
  margin: 0.5rem 0 0 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
`;

const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 10px;
  transition: all 0.3s;
  &:hover {
    background: rgba(0,240,255,0.05);
    border-color: rgba(0,240,255,0.15);
  }
`;

const FeatureIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  background: ${props => props.bg};
  flex-shrink: 0;
`;

const FeatureInfo = styled.div`
  flex: 1;
`;

const FeatureTitle = styled.div`
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
`;

const FeatureDesc = styled.div`
  font-size: 0.8rem;
  color: var(--text-secondary);
`;

const ActionButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${props => props.gradient || 'var(--primary)'};
  color: ${props => props.gradient ? '#fff' : '#000'};
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Rajdhani', sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.gradient ? '0 8px 25px rgba(0,0,0,0.3)' : 'var(--glow-primary)'};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

const ResultBox = styled.div`
  margin-top: 1rem;
  padding: 1.5rem;
  background: rgba(0,240,255,0.05);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  border-left: 4px solid var(--primary);
  white-space: pre-wrap;
  line-height: 1.8;
  color: var(--text-primary);
`;

const StepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 1rem;
`;

const StepItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 1rem;
  background: ${props => props.$status === 'completed' ? 'rgba(0,255,136,0.08)' : props.$status === 'processing' ? 'rgba(255,170,0,0.08)' : 'rgba(255,255,255,0.03)'};
  border: 1px solid ${props => props.$status === 'completed' ? 'rgba(0,255,136,0.2)' : props.$status === 'processing' ? 'rgba(255,170,0,0.2)' : 'rgba(255,255,255,0.05)'};
  border-radius: 8px;
`;

const StepStatus = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${props => props.$status === 'completed' ? 'var(--success)' : props.$status === 'processing' ? 'var(--warning)' : 'rgba(255,255,255,0.2)'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-size: 0.75rem;
  font-weight: 700;
`;

const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 1rem;
`;

const TaskItem = styled.div`
  padding: 1rem;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-primary);
`;

const ProgressBar = styled.div`
  width: 100px;
  height: 8px;
  background: rgba(255,255,255,0.1);
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressFill = styled.div`
  width: ${props => props.$progress}%;
  height: 100%;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  border-radius: 4px;
  transition: width 0.3s;
`;

const PlatformGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin: 1rem 0;
`;

const PlatformCard = styled.div`
  padding: 1.5rem;
  background: ${props => props.$selected ? 'rgba(0,240,255,0.08)' : 'rgba(255,255,255,0.03)'};
  border: 2px solid ${props => props.$selected ? 'var(--primary)' : 'rgba(255,255,255,0.08)'};
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    border-color: var(--primary);
    background: rgba(0,240,255,0.05);
  }
`;

const PlatformIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: var(--glow-primary);
  }
  &::placeholder {
    color: var(--text-secondary);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 1rem;
  resize: vertical;
  min-height: 120px;
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: var(--glow-primary);
  }
  &::placeholder {
    color: var(--text-secondary);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.8rem 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: var(--glow-primary);
  }
`;

const UploadArea = styled.div`
  border: 2px dashed var(--border-color);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  color: var(--text-secondary);
  &:hover {
    border-color: var(--primary);
    background: rgba(0,240,255,0.05);
    color: var(--primary);
  }
`;

const ConfigCard = styled.div`
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
`;

const ConfigTitle = styled.h3`
  font-family: 'Orbitron', sans-serif;
  color: var(--primary);
  margin-bottom: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.1rem;
  letter-spacing: 1px;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.$configured ? 'rgba(0, 255, 136, 0.15)' : 'rgba(255, 51, 102, 0.15)'};
  color: ${props => props.$configured ? 'var(--success)' : 'var(--danger)'};
  border: 1px solid ${props => props.$configured ? 'rgba(0, 255, 136, 0.3)' : 'rgba(255, 51, 102, 0.3)'};
`;

const InfoBox = styled.div`
  background: rgba(0, 240, 255, 0.05);
  border: 1px solid rgba(0, 240, 255, 0.15);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  h4 {
    color: var(--primary);
    font-size: 14px;
    margin-bottom: 8px;
  }
  p {
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.6;
    margin: 0;
  }
  a {
    color: var(--primary);
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const Message = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 8px;
  background: ${props => props.$error ? 'rgba(255, 51, 102, 0.1)' : 'rgba(0, 255, 136, 0.1)'};
  color: ${props => props.$error ? 'var(--danger)' : 'var(--success)'};
  border: 1px solid ${props => props.$error ? 'rgba(255, 51, 102, 0.3)' : 'rgba(0, 255, 136, 0.3)'};
`;

const ConfigReadOnly = styled.div`
  background: rgba(0,240,255,0.03);
  border: 1px solid rgba(0,240,255,0.1);
  border-radius: 10px;
  padding: 1rem 1.25rem;
`;

const ConfigRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 0;
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255,255,255,0.05);
  }
`;

const ConfigLabel = styled.span`
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ConfigValue = styled.span`
  font-size: 0.9rem;
  color: var(--text-primary);
  font-family: 'Rajdhani', monospace;
`;

const EmptyConfigHint = styled.div`
  text-align: center;
  padding: 1.5rem;
  background: rgba(255,170,0,0.05);
  border: 1px dashed rgba(255,170,0,0.2);
  border-radius: 10px;
  p {
    color: var(--warning);
    margin: 0.25rem 0;
    font-size: 0.9rem;
  }
`;

const ResultField = styled.p`
  margin: 0.5rem 0;
  color: var(--text-primary);
  line-height: 1.8;
  font-size: 0.95rem;
`;

const ResultLabel = styled.span`
  color: var(--primary);
  font-weight: 600;
`;

const ResultList = styled.ul`
  margin: 0.5rem 0 0.5rem 1.25rem;
  list-style: disc;
  color: var(--text-primary);
`;

const ResultListItem = styled.li`
  margin: 0.35rem 0;
  line-height: 1.6;
  color: var(--text-primary);
  font-size: 0.9rem;
`;

const ResultContentWrapper = styled.pre`
  white-space: pre-wrap;
  font-family: inherit;
  color: var(--text-primary);
  line-height: 2;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 8px;
  padding: 1.25rem;
  margin: 1rem 0;
`;

// ==================== IP大脑子页面 ====================
const IPBrainPage = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('benchmark');
  const [inputText, setInputText] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await api.get('/ipbrain/history');
      if (res.data.code === 1) {
        setHistory(res.data.data || []);
      }
    } catch (err) {
      console.error('获取历史失败:', err);
    }
  };

  const handleAnalyze = async () => {
    if (!inputText.trim()) {
      alert('请输入内容');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/ipbrain/analyze', {
        type: activeTab,
        input_text: inputText
      });
      if (res.data.code === 1) {
        setResult(res.data.data);
        fetchHistory();
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      alert('请求失败: ' + err.message);
    }
    setLoading(false);
  };

  const typeLabels = { benchmark: '对标账号', viral: '爆款视频', ai: 'AI文案' };

  const formatTime = (ts) => {
    if (!ts) return '';
    const d = new Date(parseInt(ts) * 1000);
    return d.toLocaleString('zh-CN');
  };

  return (
    <div>
      <Header>
        <Logo>
          <LogoIcon>🧠</LogoIcon>
          <LogoText>IP大脑</LogoText>
        </Logo>
        <UserMenu>
          <ActionButton onClick={() => { setShowHistory(!showHistory); fetchHistory(); }}>
            📋 记录 ({history.length})
          </ActionButton>
          <ActionButton onClick={onBack}>返回</ActionButton>
        </UserMenu>
      </Header>
      <MainContent>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'flex', gap: '1rem', marginBottom: '2rem'}}>
            {[
              { key: 'benchmark', label: '🎯 对标账号', gradient: 'linear-gradient(135deg, #667eea, #764ba2)' },
              { key: 'viral', label: '🔥 爆款视频', gradient: 'linear-gradient(135deg, #f093fb, #f5576c)' },
              { key: 'ai', label: '✨ AI生成', gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)' }
            ].map(tab => (
              <ActionButton
                key={tab.key}
                gradient={tab.gradient}
                onClick={() => { setActiveTab(tab.key); setResult(null); }}
                style={{
                  background: activeTab === tab.key ? tab.gradient : 'rgba(255,255,255,0.06)',
                  color: activeTab === tab.key ? '#fff' : 'var(--text-secondary)'
                }}
              >
                {tab.label}
              </ActionButton>
            ))}
          </div>

          {/* 分析输入区 */}
          <div style={{background: 'var(--bg-card)', border: '1px solid var(--border-color)', borderRadius: '16px', padding: '2rem'}}>
            <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>
              {activeTab === 'benchmark' && '🎯 对标账号分析'}
              {activeTab === 'viral' && '🔥 爆款视频分析'}
              {activeTab === 'ai' && '✨ AI文案生成'}
            </h3>
            <TextArea
              placeholder={
                activeTab === 'benchmark' ? '输入对标账号名称或描述，例如：李佳琦、疯狂小杨哥...' :
                activeTab === 'viral' ? '输入视频主题或描述，例如：搞笑舞蹈、美食教程...' :
                '输入文案主题，例如：如何打造个人IP、AI创业指南...'
              }
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
            />
            <div style={{marginTop: '1rem'}}>
              <ActionButton
                gradient={
                  activeTab === 'benchmark' ? 'linear-gradient(135deg, #667eea, #764ba2)' :
                  activeTab === 'viral' ? 'linear-gradient(135deg, #f093fb, #f5576c)' :
                  'linear-gradient(135deg, #4facfe, #00f2fe)'
                }
                onClick={handleAnalyze}
                disabled={loading}
              >
                {loading ? '分析中...' : '开始分析'}
              </ActionButton>
            </div>

            {/* 分析结果 */}
            {result && (
              <ResultBox>
                {activeTab === 'benchmark' && result.analysis && (
                  <div>
                    <h4 style={{color: 'var(--primary)', marginBottom: '1rem', fontSize: '1.1rem'}}>📊 对标账号分析结果</h4>
                    <ResultField><ResultLabel>账号：</ResultLabel>{result.analysis.account_name}</ResultField>
                    <ResultField><ResultLabel>粉丝数：</ResultLabel>{result.analysis.followers}</ResultField>
                    <ResultField><ResultLabel>平均播放：</ResultLabel>{result.analysis.avg_views}</ResultField>
                    <ResultField><ResultLabel>内容策略：</ResultLabel>{result.analysis.content_strategy}</ResultField>
                    <ResultField><ResultLabel>发布频率：</ResultLabel>{result.analysis.posting_frequency}</ResultField>
                    <ResultField><ResultLabel>互动率：</ResultLabel>{result.analysis.engagement_rate}</ResultField>
                    <ResultField>
                      <ResultLabel>热门话题：</ResultLabel>
                      {result.analysis.top_topics?.join('、')}
                    </ResultField>
                    <h4 style={{color: 'var(--primary)', margin: '1.2rem 0 0.8rem', fontSize: '1rem'}}>💡 建议</h4>
                    <ResultList>
                      {result.analysis.recommendations?.map((r, i) => (
                        <ResultListItem key={i}>{r}</ResultListItem>
                      ))}
                    </ResultList>
                  </div>
                )}
                {activeTab === 'viral' && result.analysis && (
                  <div>
                    <h4 style={{color: 'var(--primary)', marginBottom: '1rem', fontSize: '1.1rem'}}>🔥 爆款视频分析结果</h4>
                    <ResultField><ResultLabel>标题：</ResultLabel>{result.analysis.video_title}</ResultField>
                    <h4 style={{color: 'var(--primary)', margin: '1.2rem 0 0.8rem', fontSize: '1rem'}}>🔑 爆款因素</h4>
                    <ResultList>
                      {result.analysis.viral_factors?.map((f, i) => (
                        <ResultListItem key={i}>{f}</ResultListItem>
                      ))}
                    </ResultList>
                    {result.analysis.structure_analysis && (
                      <>
                        <h4 style={{color: 'var(--primary)', margin: '1.2rem 0 0.8rem', fontSize: '1rem'}}>📐 结构分析</h4>
                        <ResultField><ResultLabel>开头：</ResultLabel>{result.analysis.structure_analysis.hook}</ResultField>
                        <ResultField><ResultLabel>正文：</ResultLabel>{result.analysis.structure_analysis.body}</ResultField>
                        <ResultField><ResultLabel>结尾：</ResultLabel>{result.analysis.structure_analysis.cta}</ResultField>
                      </>
                    )}
                  </div>
                )}
                {activeTab === 'ai' && result.generated_content && (
                  <div>
                    <h4 style={{color: 'var(--primary)', marginBottom: '1rem', fontSize: '1.1rem'}}>📝 AI文案生成结果</h4>
                    <h4 style={{color: 'var(--text-primary)', marginBottom: '0.8rem', fontSize: '1.2rem', textAlign: 'center'}}>
                      {result.generated_content.title}
                    </h4>
                    <ResultContentWrapper>
                      {result.generated_content.content}
                    </ResultContentWrapper>
                    <ResultField style={{marginTop: '1rem'}}>
                      <ResultLabel>关键词：</ResultLabel>
                      {result.generated_content.keywords?.join('、')}
                    </ResultField>
                    <ResultField>
                      <ResultLabel>推荐标签：</ResultLabel>
                      {result.generated_content.suggested_tags?.join(' ')}
                    </ResultField>
                  </div>
                )}
              </ResultBox>
            )}
          </div>

          {/* 历史记录列表 */}
          {showHistory && (
            <div style={{marginTop: '2rem'}}>
              <div style={{background: 'var(--bg-card)', border: '1px solid var(--border-color)', borderRadius: '16px', padding: '1.5rem'}}>
                <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>
                  📋 分析记录 ({history.length})
                </h3>
                {history.length === 0 ? (
                  <p style={{color: 'var(--text-secondary)', textAlign: 'center', padding: '2rem'}}>暂无分析记录</p>
                ) : (
                  <TaskList>
                    {history.map((item) => (
                      <TaskItem key={item.task_id} style={{cursor: 'pointer', flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem'}}
                        onClick={() => {
                          if (item.result) {
                            setActiveTab(item.analysis_type);
                            setResult(item.result);
                            setShowHistory(false);
                          }
                        }}
                      >
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                          <span style={{color: 'var(--text-primary)', fontWeight: 600}}>
                            {typeLabels[item.analysis_type] || item.analysis_type} 分析
                          </span>
                          <span style={{color: 'var(--text-secondary)', fontSize: '0.8rem'}}>
                            {formatTime(item.created_at)}
                          </span>
                        </div>
                        <span style={{color: 'var(--text-secondary)', fontSize: '0.85rem'}}>
                          {item.input_text}
                        </span>
                      </TaskItem>
                    ))}
                  </TaskList>
                )}
              </div>
            </div>
          )}
        </div>
      </MainContent>
    </div>
  );
};

// ==================== AI分身页面 ====================
const AIAvatarPage = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('photo');
  const [avatarName, setAvatarName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [avatars, setAvatars] = useState([]);

  useEffect(() => {
    loadAvatars();
  }, []);

  const loadAvatars = async () => {
    try {
      const res = await api.get('/avatar/list');
      if (res.data.code === 1) {
        setAvatars(res.data.data || []);
      }
    } catch (err) {
      console.error('加载分身列表失败:', err);
    }
  };

  const handleCreate = async () => {
    if (!avatarName.trim()) {
      alert('请输入分身名称');
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('avatar_name', avatarName);
      formData.append('avatar_type', activeTab);
      formData.append('description', description);
      if (selectedFile) {
        formData.append('file', selectedFile);
      }

      const res = await api.post('/avatar/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.code === 1) {
        setResult(res.data.data);
        loadAvatars();
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      alert('创建失败: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div>
      <Header>
        <Logo>
          <LogoIcon>👤</LogoIcon>
          <LogoText>AI分身</LogoText>
        </Logo>
        <UserMenu>
          <ActionButton onClick={onBack}>返回</ActionButton>
        </UserMenu>
      </Header>
      <MainContent>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'flex', gap: '1rem', marginBottom: '2rem'}}>
            {[
              { key: 'photo', label: '📷 照片数字人', gradient: 'linear-gradient(135deg, #fa709a, #fee140)' },
              { key: 'video', label: '🎬 口播视频', gradient: 'linear-gradient(135deg, #a8edea, #fed6e3)' },
              { key: 'clone', label: '🔄 一键克隆', gradient: 'linear-gradient(135deg, #d299c2, #fef9d7)' }
            ].map(tab => (
              <ActionButton
                key={tab.key}
                gradient={tab.gradient}
                onClick={() => { setActiveTab(tab.key); setResult(null); }}
                style={{
                  background: activeTab === tab.key ? tab.gradient : 'rgba(255,255,255,0.06)',
                  color: activeTab === tab.key ? '#fff' : 'var(--text-secondary)'
                }}
              >
                {tab.label}
              </ActionButton>
            ))}
          </div>

          <div style={{background: 'var(--bg-card)', border: '1px solid var(--border-color)', borderRadius: '16px', padding: '2rem'}}>
            <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>
              {activeTab === 'photo' && '📷 照片数字人生成'}
              {activeTab === 'video' && '🎬 口播视频制作'}
              {activeTab === 'clone' && '🔄 一键克隆数字分身'}
            </h3>

            <div style={{marginBottom: '1rem'}}>
              <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: 'var(--text-secondary)'}}>分身名称</label>
              <Input
                placeholder="请输入分身名称"
                value={avatarName}
                onChange={(e) => setAvatarName(e.target.value)}
              />
            </div>

            <div style={{marginBottom: '1rem'}}>
              <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: 'var(--text-secondary)'}}>描述</label>
              <TextArea
                placeholder="请输入描述信息"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{minHeight: '80px'}}
              />
            </div>

            {activeTab === 'photo' && (
              <UploadArea onClick={() => document.getElementById('avatar-file-input').click()}>
                <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📤</div>
                <p>{selectedFile ? selectedFile.name : '拖拽照片到此处或点击上传'}</p>
                <input
                  id="avatar-file-input"
                  type="file"
                  accept="image/*"
                  style={{display: 'none'}}
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </UploadArea>
            )}

            {activeTab === 'clone' && (
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1rem'}}>
                {[
                  { step: 1, name: '上传素材', desc: '上传3-5张清晰照片' },
                  { step: 2, name: '选择风格', desc: '选择数字人风格模板' },
                  { step: 3, name: '生成模型', desc: 'AI自动训练数字分身' },
                  { step: 4, name: '开始使用', desc: '使用数字分身创作内容' }
                ].map(s => (
                  <div key={s.step} style={{padding: '1rem', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '10px'}}>
                    <h4 style={{color: 'var(--text-primary)'}}>步骤{s.step}：{s.name}</h4>
                    <p style={{fontSize: '0.9rem', color: 'var(--text-secondary)'}}>{s.desc}</p>
                  </div>
                ))}
              </div>
            )}

            <ActionButton
              gradient={
                activeTab === 'photo' ? 'linear-gradient(135deg, #fa709a, #fee140)' :
                activeTab === 'video' ? 'linear-gradient(135deg, #a8edea, #fed6e3)' :
                'linear-gradient(135deg, #d299c2, #fef9d7)'
              }
              onClick={handleCreate}
              disabled={loading}
            >
              {loading ? '创建中...' : '开始创建'}
            </ActionButton>

            {result && result.steps && (
              <div style={{marginTop: '1.5rem'}}>
                <h4>📋 创建进度</h4>
                <StepList>
                  {result.steps.map((step, i) => (
                    <StepItem $status={step.status}>
                      <StepStatus $status={step.status}>
                        {step.status === 'completed' ? '✓' : step.status === 'processing' ? '⏳' : '○'}
                      </StepStatus>
                      <div>
                        <strong>步骤{step.step}：{step.name}</strong>
                        <div style={{fontSize: '0.8rem', color: 'var(--text-secondary)'}}>
                          状态: {step.status === 'completed' ? '已完成' : step.status === 'processing' ? '进行中' : '等待中'}
                        </div>
                      </div>
                    </StepItem>
                  ))}
                </StepList>
                {result.estimated_time && (
                  <p style={{marginTop: '1rem', color: 'var(--text-secondary)'}}>⏱️ 预计时间: {result.estimated_time}</p>
                )}
              </div>
            )}

            {avatars.length > 0 && (
              <div style={{marginTop: '2rem'}}>
                <h4 style={{color: 'var(--text-primary)'}}>📂 我的分身</h4>
                <TaskList>
                  {avatars.map(av => (
                    <TaskItem key={av.avatar_id}>
                      <div>
                        <strong>{av.avatar_name}</strong>
                        <div style={{fontSize: '0.8rem', color: 'var(--text-secondary)'}}>
                          类型: {av.avatar_type} | 状态: {av.status}
                        </div>
                      </div>
                      <span style={{
                        padding: '0.3rem 0.8rem',
                        borderRadius: '12px',
                        background: av.status === 'ready' ? '#e8f5e9' : '#fff3e0',
                        color: av.status === 'ready' ? '#4caf50' : '#ff9800',
                        fontSize: '0.8rem'
                      }}>
                        {av.status === 'ready' ? '可用' : '处理中'}
                      </span>
                    </TaskItem>
                  ))}
                </TaskList>
              </div>
            )}
          </div>
        </div>
      </MainContent>
    </div>
  );
};

// ==================== 创作与分发页面 ====================
const CreateDistPage = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('create');
  const [digitalHumanId, setDigitalHumanId] = useState('');
  const [voiceId, setVoiceId] = useState('');
  const [text, setText] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [title, setTitle] = useState('');
  const [tags, setTags] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const res = await api.get('/video/tasks');
      if (res.data.code === 1) {
        setTasks(res.data.data || []);
      }
    } catch (err) {
      console.error('加载任务列表失败:', err);
    }
  };

  const togglePlatform = (platform) => {
    setPlatforms(prev =>
      prev.includes(platform)
        ? prev.filter(p => p !== platform)
        : [...prev, platform]
    );
  };

  const handleCreate = async () => {
    if (!text.trim()) {
      alert('请输入文案');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/video/create', {
        digital_human_id: digitalHumanId || 'default',
        voice_id: voiceId || 'default',
        text: text
      });
      if (res.data.code === 1) {
        setResult(res.data.data);
        loadTasks();
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      alert('创建失败: ' + err.message);
    }
    setLoading(false);
  };

  const handleSmartEdit = async () => {
    if (!selectedFile) {
      alert('请选择视频文件');
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('edit_type', 'auto');
      formData.append('options', '{}');

      const res = await api.post('/video/smart-edit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.code === 1) {
        setResult(res.data.data);
        loadTasks();
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      alert('剪辑失败: ' + err.message);
    }
    setLoading(false);
  };

  const handleDistribute = async () => {
    if (platforms.length === 0) {
      alert('请选择分发平台');
      return;
    }
    if (!title.trim()) {
      alert('请输入标题');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/video/distribute', {
        video_id: 'default',
        platforms: platforms,
        title: title,
        description: '',
        tags: tags.split(',').map(t => t.trim()).filter(Boolean)
      });
      if (res.data.code === 1) {
        setResult(res.data.data);
        loadTasks();
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      alert('分发失败: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div>
      <Header>
        <Logo>
          <LogoIcon>🚀</LogoIcon>
          <LogoText>创作与分发</LogoText>
        </Logo>
        <UserMenu>
          <ActionButton onClick={onBack}>返回</ActionButton>
        </UserMenu>
      </Header>
      <MainContent>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'flex', gap: '1rem', marginBottom: '2rem'}}>
            {[
              { key: 'create', label: '🎬 视频创作', gradient: 'linear-gradient(135deg, #43e97b, #38f9d7)' },
              { key: 'edit', label: '✂️ 智能剪辑', gradient: 'linear-gradient(135deg, #fa709a, #fee140)' },
              { key: 'dist', label: '📤 一键分发', gradient: 'linear-gradient(135deg, #667eea, #764ba2)' }
            ].map(tab => (
              <ActionButton
                key={tab.key}
                gradient={tab.gradient}
                onClick={() => { setActiveTab(tab.key); setResult(null); }}
                style={{
                  background: activeTab === tab.key ? tab.gradient : 'rgba(255,255,255,0.06)',
                  color: activeTab === tab.key ? '#fff' : 'var(--text-secondary)'
                }}
              >
                {tab.label}
              </ActionButton>
            ))}
          </div>

          <div style={{background: 'var(--bg-card)', border: '1px solid var(--border-color)', borderRadius: '16px', padding: '2rem'}}>
            {activeTab === 'create' && (
              <div>
                <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>🎬 数字人口播视频</h3>
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1rem'}}>
                  <div>
                    <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: 'var(--text-secondary)'}}>选择数字人</label>
                    <Select value={digitalHumanId} onChange={(e) => setDigitalHumanId(e.target.value)}>
                      <option value="">选择数字人模型</option>
                      <option value="dh1">数字人1</option>
                      <option value="dh2">数字人2</option>
                    </Select>
                  </div>
                  <div>
                    <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: 'var(--text-secondary)'}}>选择音色</label>
                    <Select value={voiceId} onChange={(e) => setVoiceId(e.target.value)}>
                      <option value="">选择音色</option>
                      <option value="v1">男声1</option>
                      <option value="v2">女声1</option>
                    </Select>
                  </div>
                </div>
                <div style={{marginBottom: '1rem'}}>
                  <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600, color: 'var(--text-secondary)'}}>输入文案</label>
                  <TextArea
                    placeholder="输入口播文案..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                  />
                </div>
                <ActionButton
                  gradient="linear-gradient(135deg, #43e97b, #38f9d7)"
                  onClick={handleCreate}
                  disabled={loading}
                >
                  {loading ? '生成中...' : '生成视频'}
                </ActionButton>
              </div>
            )}

            {activeTab === 'edit' && (
              <div>
                <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>✂️ AI智能剪辑</h3>
                <UploadArea onClick={() => document.getElementById('edit-file-input').click()}>
                  <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📤</div>
                  <p>{selectedFile ? selectedFile.name : '拖拽视频到此处或点击上传'}</p>
                  <input
                    id="edit-file-input"
                    type="file"
                    accept="video/*"
                    style={{display: 'none'}}
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                </UploadArea>
                <ActionButton
                  gradient="linear-gradient(135deg, #fa709a, #fee140)"
                  onClick={handleSmartEdit}
                  disabled={loading}
                >
                  {loading ? '剪辑中...' : '开始剪辑'}
                </ActionButton>
              </div>
            )}

            {activeTab === 'dist' && (
              <div>
                <h3 style={{color: 'var(--primary)', fontFamily: "'Orbitron',sans-serif", marginBottom: '1rem', fontSize: '1.1rem'}}>📤 多平台一键分发</h3>
                <PlatformGrid>
                  {[
                    { key: 'douyin', icon: '📱', name: '抖音' },
                    { key: 'kuaishou', icon: '📺', name: '快手' },
                    { key: 'video_account', icon: '💬', name: '视频号' }
                  ].map(p => (
                    <PlatformCard
                      key={p.key}
                      selected={platforms.includes(p.key)}
                      onClick={() => togglePlatform(p.key)}
                    >
                      <PlatformIcon>{p.icon}</PlatformIcon>
                      <div>{p.name}</div>
                      <div style={{fontSize: '0.8rem', color: platforms.includes(p.key) ? '#2196f3' : '#999'}}>
                        {platforms.includes(p.key) ? '✓ 已选' : '点击选择'}
                      </div>
                    </PlatformCard>
                  ))}
                </PlatformGrid>
                <div style={{marginBottom: '1rem'}}>
                  <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600}}>标题</label>
                  <Input
                    placeholder="请输入视频标题"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
                <div style={{marginBottom: '1rem'}}>
                  <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 600}}>标签（逗号分隔）</label>
                  <Input
                    placeholder="例如: AI, 数字人, 科技"
                    value={tags}
                    onChange={(e) => setTags(e.target.value)}
                  />
                </div>
                <ActionButton
                  gradient="linear-gradient(135deg, #667eea, #764ba2)"
                  onClick={handleDistribute}
                  disabled={loading}
                >
                  {loading ? '分发中...' : '一键分发'}
                </ActionButton>
              </div>
            )}

            {result && result.steps && (
              <div style={{marginTop: '1.5rem'}}>
                <h4>📋 处理进度</h4>
                <StepList>
                  {result.steps.map((step, i) => (
                    <StepItem key={i} status={step.status}>
                      <StepStatus $status={step.status}>
                        {step.status === 'completed' ? '✓' : step.status === 'processing' ? '⏳' : '○'}
                      </StepStatus>
                      <div>
                        <strong>步骤{step.step}：{step.name}</strong>
                        <div style={{fontSize: '0.8rem', color: 'var(--text-secondary)'}}>
                          状态: {step.status === 'completed' ? '已完成' : step.status === 'processing' ? '进行中' : '等待中'}
                        </div>
                      </div>
                    </StepItem>
                  ))}
                </StepList>
                {result.estimated_time && (
                  <p style={{marginTop: '1rem', color: 'var(--text-secondary)'}}>⏱️ 预计时间: {result.estimated_time}</p>
                )}
              </div>
            )}

            {tasks.length > 0 && (
              <div style={{marginTop: '2rem'}}>
                <h4 style={{color: 'var(--text-primary)'}}>📋 任务列表</h4>
                <TaskList>
                  {tasks.map(task => (
                    <TaskItem key={task.task_id}>
                      <div>
                        <strong style={{color: 'var(--text-primary)'}}>{task.title}</strong>
                        <div style={{fontSize: '0.8rem', color: 'var(--text-secondary)'}}>
                          类型: {task.task_type} | 状态: {task.status}
                        </div>
                      </div>
                      {task.progress !== undefined && (
                        <ProgressBar>
                          <ProgressFill $progress={task.progress} />
                        </ProgressBar>
                      )}
                    </TaskItem>
                  ))}
                </TaskList>
              </div>
            )}
          </div>
        </div>
      </MainContent>
    </div>
  );
};

// ==================== API配置页面 ====================
const APIConfigPage = ({ onBack }) => {
  const [activeTab, setActiveTab] = useState('ipbrain');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [testResult, setTestResult] = useState(null);
  
  // 从统一配置中心读取的配置状态
  const [centralConfig, setCentralConfig] = useState({
    deepseek_configured: false,
    deepseek_model: '',
    deepseek_api_base: '',
    niwa_configured: false,
    niwa_app_id: '',
    niwa_api_base: ''
  });
  
  const [createdistConfig, setCreatedistConfig] = useState({
    douyin_api_key: '',
    kuaishou_api_key: '',
    video_account_api_key: '',
    enabled: true
  });

  const [configStatus, setConfigStatus] = useState({
    ipbrain: { configured: false },
    aiavatar: { configured: false },
    createdist: { configured: false }
  });

  const CENTRAL_CONFIG_URL = '/api/v1/user/config';

  useEffect(() => {
    fetchCentralConfig();
  }, []);

  const fetchCentralConfig = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(CENTRAL_CONFIG_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.code === 1 && data.data) {
        const d = data.data;
        setCentralConfig({
          deepseek_configured: d.deepseek_configured || false,
          deepseek_model: d.deepseek_model || 'deepseek-chat',
          deepseek_api_base: d.deepseek_api_base || 'https://api.deepseek.com/v1',
          niwa_configured: d.configured || false,
          niwa_app_id: d.app_id || '',
          niwa_api_base: d.api_base_url || 'https://vapi.niwaai.com'
        });
      }
    } catch (err) {
      console.error('获取中央配置失败:', err);
    }
  };

  const goToConfigCenter = () => {
    window.location.href = '/config';
  };

  const handleSaveCreatedist = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const res = await configApi.post('/config/createdist', createdistConfig);
      if (res.data.code === 1) {
        setMessage({ type: 'success', text: '创作分发配置保存成功' });
        fetchCentralConfig();
      } else {
        setMessage({ type: 'error', text: res.data.msg });
      }
    } catch (err) {
      setMessage({ type: 'error', text: '保存失败: ' + err.message });
    }
    setLoading(false);
  };

  return (
    <div>
      <Header>
        <Logo>
          <LogoIcon>⚙️</LogoIcon>
          <LogoText>API配置</LogoText>
        </Logo>
        <UserMenu>
          <ActionButton onClick={onBack}>返回</ActionButton>
        </UserMenu>
      </Header>
      <MainContent>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{display: 'flex', gap: '1rem', marginBottom: '2rem'}}>
            {[
              { key: 'ipbrain', label: '🧠 IP大脑配置', gradient: 'linear-gradient(135deg, #667eea, #764ba2)' },
              { key: 'aiavatar', label: '👤 AI分身配置', gradient: 'linear-gradient(135deg, #fa709a, #fee140)' },
              { key: 'createdist', label: '🚀 创作分发配置', gradient: 'linear-gradient(135deg, #43e97b, #38f9d7)' }
            ].map(tab => (
              <ActionButton
                key={tab.key}
                gradient={tab.gradient}
                onClick={() => { setActiveTab(tab.key); setMessage(null); setTestResult(null); }}
                style={{
                  background: activeTab === tab.key ? tab.gradient : 'rgba(255,255,255,0.06)',
                  color: activeTab === tab.key ? '#fff' : 'var(--text-secondary)'
                }}
              >
                {tab.label}
              </ActionButton>
            ))}
          </div>

          {activeTab === 'ipbrain' && (
            <ConfigCard>
              <ConfigTitle>
                🧠 IP大脑API配置
                <StatusBadge $configured={centralConfig.deepseek_configured}>
                  {centralConfig.deepseek_configured ? '✓ 已配置' : '○ 未配置'}
                </StatusBadge>
              </ConfigTitle>

              <InfoBox>
                <h4>📌 配置说明</h4>
                <p>
                  IP大脑使用 <strong>DeepSeek AI</strong> 大模型接口<br/>
                  支持 DeepSeek-V3（通用对话）和 DeepSeek-R1（深度推理）<br/>
                  可用于对标账号分析、爆款视频分析、AI文案生成等功能<br/>
                  在 <a href="/config" style={{color: 'var(--primary)'}}>⚙️ 配置中心 → 🧠 DeepSeek AI</a> 统一管理
                </p>
              </InfoBox>

              {centralConfig.deepseek_configured ? (
                <ConfigReadOnly>
                  <ConfigRow>
                    <ConfigLabel>API地址</ConfigLabel>
                    <ConfigValue>{centralConfig.deepseek_api_base}</ConfigValue>
                  </ConfigRow>
                  <ConfigRow>
                    <ConfigLabel>模型</ConfigLabel>
                    <ConfigValue>
                      {centralConfig.deepseek_model === 'deepseek-chat' ? 'DeepSeek-V3 (通用对话)' : 'DeepSeek-R1 (深度推理)'}
                    </ConfigValue>
                  </ConfigRow>
                  <ConfigRow>
                    <ConfigLabel>API Key</ConfigLabel>
                    <ConfigValue style={{color: 'var(--success)'}}>****已设置****</ConfigValue>
                  </ConfigRow>
                </ConfigReadOnly>
              ) : (
                <EmptyConfigHint>
                  <p>⚠️ 尚未配置 DeepSeek API Key</p>
                  <p>请在配置中心设置以启用IP大脑AI功能</p>
                </EmptyConfigHint>
              )}

              <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
                <ActionButton
                  gradient="linear-gradient(135deg, #667eea, #764ba2)"
                  onClick={goToConfigCenter}
                >
                  ⚙️ 前往配置中心
                </ActionButton>
                <ActionButton
                  gradient="linear-gradient(135deg, #43e97b, #38f9d7)"
                  onClick={async () => {
                    await fetchCentralConfig();
                    setMessage({ type: 'success', text: '配置状态已刷新' });
                  }}
                >
                  🔄 刷新状态
                </ActionButton>
              </div>

              {message && (
                <Message $error={message.type === 'error'}>
                  {message.text}
                </Message>
              )}
            </ConfigCard>
          )}

          {activeTab === 'aiavatar' && (
            <ConfigCard>
              <ConfigTitle>
                👤 AI分身API配置
                <StatusBadge $configured={centralConfig.niwa_configured}>
                  {centralConfig.niwa_configured ? '✓ 已配置' : '○ 未配置'}
                </StatusBadge>
              </ConfigTitle>

              <InfoBox>
                <h4>📌 配置说明</h4>
                <p>
                  AI分身使用 <strong>拟娲数字人API凭证</strong> 进行数字人生成<br/>
                  支持照片数字人、口播视频、一键克隆等功能<br/>
                  在 <a href="/config" style={{color: 'var(--primary)'}}>⚙️ 配置中心 → 🔑 API配置</a> 统一管理
                </p>
              </InfoBox>

              {centralConfig.niwa_configured ? (
                <ConfigReadOnly>
                  <ConfigRow>
                    <ConfigLabel>APP ID</ConfigLabel>
                    <ConfigValue>{centralConfig.niwa_app_id}</ConfigValue>
                  </ConfigRow>
                  <ConfigRow>
                    <ConfigLabel>API地址</ConfigLabel>
                    <ConfigValue>{centralConfig.niwa_api_base}</ConfigValue>
                  </ConfigRow>
                  <ConfigRow>
                    <ConfigLabel>APP Secret</ConfigLabel>
                    <ConfigValue style={{color: 'var(--success)'}}>****已设置****</ConfigValue>
                  </ConfigRow>
                </ConfigReadOnly>
              ) : (
                <EmptyConfigHint>
                  <p>⚠️ 尚未配置拟娲数字人API凭证</p>
                  <p>请在配置中心设置 APP_ID 和 APP_SECRET</p>
                </EmptyConfigHint>
              )}

              <div style={{display: 'flex', gap: '1rem', marginTop: '1rem'}}>
                <ActionButton
                  gradient="linear-gradient(135deg, #fa709a, #fee140)"
                  onClick={goToConfigCenter}
                >
                  ⚙️ 前往配置中心
                </ActionButton>
                <ActionButton
                  gradient="linear-gradient(135deg, #43e97b, #38f9d7)"
                  onClick={async () => {
                    await fetchCentralConfig();
                    setMessage({ type: 'success', text: '配置状态已刷新' });
                  }}
                >
                  🔄 刷新状态
                </ActionButton>
              </div>

              {message && (
                <Message $error={message.type === 'error'}>
                  {message.text}
                </Message>
              )}
            </ConfigCard>
          )}

          {activeTab === 'createdist' && (
            <ConfigCard>
              <ConfigTitle>
                🚀 创作分发API配置
                <StatusBadge $configured={configStatus.createdist?.douyin_configured || configStatus.createdist?.kuaishou_configured || configStatus.createdist?.video_account_configured}>
                  {(configStatus.createdist?.douyin_configured || configStatus.createdist?.kuaishou_configured || configStatus.createdist?.video_account_configured) ? '✓ 已配置' : '○ 未配置'}
                </StatusBadge>
              </ConfigTitle>

              <InfoBox>
                <h4>📌 配置说明</h4>
                <p>
                  配置各平台的API接口，实现视频一键分发<br/>
                  支持抖音、快手、视频号等主流平台
                </p>
              </InfoBox>

              <FormGroup>
                <Label>📱 抖音 API Key</Label>
                <Input
                  type="password"
                  placeholder="请输入抖音API Key"
                  value={createdistConfig.douyin_api_key}
                  onChange={(e) => setCreatedistConfig({...createdistConfig, douyin_api_key: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <Label>📺 快手 API Key</Label>
                <Input
                  type="password"
                  placeholder="请输入快手API Key"
                  value={createdistConfig.kuaishou_api_key}
                  onChange={(e) => setCreatedistConfig({...createdistConfig, kuaishou_api_key: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <Label>💬 视频号 API Key</Label>
                <Input
                  type="password"
                  placeholder="请输入视频号API Key"
                  value={createdistConfig.video_account_api_key}
                  onChange={(e) => setCreatedistConfig({...createdistConfig, video_account_api_key: e.target.value})}
                />
              </FormGroup>

              <ActionButton
                gradient="linear-gradient(135deg, #43e97b, #38f9d7)"
                onClick={handleSaveCreatedist}
                disabled={loading}
              >
                {loading ? '保存中...' : '保存配置'}
              </ActionButton>

              {message && (
                <Message $error={message.type === 'error'}>
                  {message.text}
                </Message>
              )}
            </ConfigCard>
          )}
        </div>
      </MainContent>
    </div>
  );
};

// ==================== 主页面组件 ====================
const SuperIPPage = () => {
  const [currentPage, setCurrentPage] = useState('home');

  if (currentPage === 'ipbrain') {
    return <IPBrainPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'aiavatar') {
    return <AIAvatarPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'createdist') {
    return <CreateDistPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'config') {
    return <APIConfigPage onBack={() => setCurrentPage('home')} />;
  }

  return (
    <Container>
      <Header>
        <Logo>
          <LogoIcon>🚀</LogoIcon>
          <LogoText>超级IP智能</LogoText>
        </Logo>
        <UserMenu>
          <UserAvatar>👤</UserAvatar>
          <span style={{color: 'white'}}>用户</span>
        </UserMenu>
      </Header>

      <MainContent>
        <div style={{textAlign: 'center', marginBottom: '3rem'}}>
          <h1 style={{color: 'white', fontSize: '2.5rem', marginBottom: '1rem'}}>
            普通人也能成为创作高手
          </h1>
          <p style={{color: 'rgba(255,255,255,0.8)', fontSize: '1.2rem'}}>
            轻松打造个人IP，AI赋能内容创作
          </p>
        </div>

        <ModuleGrid>
          <ModuleCard onClick={() => setCurrentPage('ipbrain')}>
            <ModuleHeader>
              <ModuleIcon gradient="linear-gradient(135deg, #667eea, #764ba2)">🧠</ModuleIcon>
              <div>
                <ModuleTitle>IP大脑</ModuleTitle>
                <ModuleDesc>基于AI大模型，提供专业的爆款AI文案服务</ModuleDesc>
              </div>
            </ModuleHeader>
            <FeatureList>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #667eea, #764ba2)">🎯</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>对标账号分析</FeatureTitle>
                  <FeatureDesc>分析对标账号内容策略和爆款逻辑</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #f093fb, #f5576c)">🔥</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>爆款视频分析</FeatureTitle>
                  <FeatureDesc>拆解爆款视频结构和创作技巧</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #4facfe, #00f2fe)">✨</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>AI文案生成</FeatureTitle>
                  <FeatureDesc>一键生成高质量文案内容</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
            </FeatureList>
          </ModuleCard>

          <ModuleCard onClick={() => setCurrentPage('aiavatar')}>
            <ModuleHeader>
              <ModuleIcon gradient="linear-gradient(135deg, #fa709a, #fee140)">👤</ModuleIcon>
              <div>
                <ModuleTitle>AI分身</ModuleTitle>
                <ModuleDesc>一键克隆数字分身，支持多种场景应用</ModuleDesc>
              </div>
            </ModuleHeader>
            <FeatureList>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #fa709a, #fee140)">📷</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>照片数字人</FeatureTitle>
                  <FeatureDesc>上传照片生成数字人形象</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #a8edea, #fed6e3)">🎬</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>口播视频</FeatureTitle>
                  <FeatureDesc>数字人口播视频制作</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #d299c2, #fef9d7)">🔄</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>一键克隆</FeatureTitle>
                  <FeatureDesc>快速完成形象生成和素材准备</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
            </FeatureList>
          </ModuleCard>

          <ModuleCard onClick={() => setCurrentPage('createdist')}>
            <ModuleHeader>
              <ModuleIcon gradient="linear-gradient(135deg, #43e97b, #38f9d7)">🚀</ModuleIcon>
              <div>
                <ModuleTitle>创作与分发</ModuleTitle>
                <ModuleDesc>支持数字人口播视频、AI智能剪辑和多平台一键分发</ModuleDesc>
              </div>
            </ModuleHeader>
            <FeatureList>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #43e97b, #38f9d7)">🎬</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>视频创作</FeatureTitle>
                  <FeatureDesc>数字人口播视频制作</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #fa709a, #fee140)">✂️</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>智能剪辑</FeatureTitle>
                  <FeatureDesc>AI智能剪辑功能</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #667eea, #764ba2)">📤</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>一键分发</FeatureTitle>
                  <FeatureDesc>多平台一键分发内容</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
            </FeatureList>
          </ModuleCard>

          <ModuleCard onClick={() => setCurrentPage('config')}>
            <ModuleHeader>
              <ModuleIcon gradient="linear-gradient(135deg, #667eea, #764ba2)">⚙️</ModuleIcon>
              <div>
                <ModuleTitle>API配置</ModuleTitle>
                <ModuleDesc>配置各模块的API接口凭证</ModuleDesc>
              </div>
            </ModuleHeader>
            <FeatureList>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #667eea, #764ba2)">🧠</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>IP大脑配置</FeatureTitle>
                  <FeatureDesc>配置OpenAI等AI大模型API</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #fa709a, #fee140)">👤</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>AI分身配置</FeatureTitle>
                  <FeatureDesc>配置D-ID/HeyGen等数字人平台</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon bg="linear-gradient(135deg, #43e97b, #38f9d7)">🚀</FeatureIcon>
                <FeatureInfo>
                  <FeatureTitle>创作分发配置</FeatureTitle>
                  <FeatureDesc>配置抖音/快手/视频号API</FeatureDesc>
                </FeatureInfo>
              </FeatureItem>
            </FeatureList>
          </ModuleCard>
        </ModuleGrid>
      </MainContent>
    </Container>
  );
};

export default SuperIPPage;
